import { Heading } from '@hover/blueprint';
import type { AccordionProps as SystemAccordionProps } from '@hover/blueprint/chakra';
import {
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
  Accordion as SystemAccordion,
  AccordionItem as SystemAccordionItem,
} from '@hover/blueprint/chakra';
import React from 'react';

export const AccordionItem: React.FC<{
  title: string;
  dataTestId?: string;
}> = ({ title, children, dataTestId }) => (
  <SystemAccordionItem data-testid={dataTestId}>
    <AccordionButton
      _hover={{ backgroundColor: 'neutral.0', cursor: 'pointer' }}
      alignItems="center"
      as="span"
      borderTopColor="neutral.200"
      borderTopStyle="solid"
      borderTopWidth="1px"
      data-test-id="accordion-button"
      display="flex"
      justifyContent="space-between"
      paddingX={0}
      paddingY={500}
    >
      <Heading fontWeight={400} margin={0} size={300}>
        {title}
      </Heading>
      <AccordionIcon height="24px" width="24px" />
    </AccordionButton>
    <AccordionPanel paddingBottom={400}>{children}</AccordionPanel>
  </SystemAccordionItem>
);

export interface AccordionProps extends SystemAccordionProps {}

export const Accordion = ({ children, ...other }: AccordionProps) => (
  <SystemAccordion allowMultiple {...other}>
    {children}
  </SystemAccordion>
);
